module.exports = __webpack_public_path__ + "img/Cao.de173aa4.jpg";